<template>
  <div class="layout-with-centered-max-width-child">
    <div>
      <footer>
      <div class="layout-with-centered-max-width-child">
        <div class="no-max">
          <div class="background">
            <div class="pure-g">
              <div class="pure-u-2-3 about-section">
                <div class="content">
                  <div>
                    <h4>GET INVOLVED!</h4>
                  </div>
                  <div class="pure-u-1-1">
                    <p>{{plugText}}</p>
                  </div>
                </div>
              </div>
              <div class="pure-u-1-3 pure-u-md-1-3">
                <div>
                  <h4>SOCIAL</h4>
                </div>
                <div>
                  <div class="social-icons">
                    <a href="https://www.facebook.com/BimiLeap/">
                      <div class="social-icon">
                        <Fai :icon="['fab', 'facebook-square']"/>
                      </div>
                    </a>
                    <a href="https://www.linkedin.com/groups/8534257/">
                      <div class="social-icon">
                        <Fai :icon="['fab', 'linkedin-in']"/>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="copyright">
            <small>
              {{copyrightText}}
            </small>
          </div>
        </div>
      </div>
    </footer>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {
    GET_COPYRIGHT_TEXT,
    STATIC_TEXT_PLUG_1,
  } from '../../services/constants'

  export default {
    name: 'Footer',
    computed: {
      ...mapGetters([
        GET_COPYRIGHT_TEXT,
      ]),
      plugText() {
        return `BimiLeap is based on the science of Mind Genomics™,
        developed by Dr. Howard Moskowitz. Dr. Moskowitz wants us to use his
        science to change the world––and we want to include people just like you!
        We're looking for researchers, students, big thinkers, life-long learners,
        grassroots organizers, entrepreneurs, lean-launchers, creative artists,
        community builders, brand ambassadors, food system leaders,
        and all kinds of curious people to be a part of what we're building.
        If that sounds like you, then sign up for your free membership in the
        BimiLearn Educational Research Center today––and don't forget
        to invite your colleagues and friends!
        `
      },
      copyrightText() {
        return this[GET_COPYRIGHT_TEXT]
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../../scss/main";

  footer {
    @media #{$mobile} {
      display: none;
    }

    .background {
      padding: 1em 4em;
      background-color: $cyan-blue-4;
      color: $white-1;
      font-weight: 300;
    }

    .about-section {
      @media #{$mobile} {
        display: none;
      }
      .content {
        padding: 0 4em 0 0;
        p {
          font-size: 80%;
        }
      }
    }

    h4 {
      margin-top: 0;
      @media #{$mobile} {
        font-weight: normal;
      }
    }

    .social-icons {
      display: flex;

      a {
        color: white;
      }

      .social-icon {
        padding: 0 .5em 0 0;
      }
    }

    .info-section-title {
      @media #{$mobile} {
        display: none;
      }
    }
    .info {
      @media #{$mobile} {
        margin: 1em 0 0 0;
      }
    }

    .copyright {
      display: flex;
      justify-content: center;
      small {
        font-size: 8px;
        padding: 2px 0;
      }
    }
  }
</style>
